import clsx from 'clsx';

interface IProps {
  prePassword: string;
  isPrePasswordCheckedBtn: boolean;
  isPwdCheckFailedModalOpen: boolean;
  onChangePassword: (e: React.SyntheticEvent<HTMLInputElement>) => void;
  onClickPwdNextBtn: () => void;
  onClickPwdCheckFailedModalClose: () => void;
}

const PwdSettingView = ({
  isPrePasswordCheckedBtn,
  prePassword,
  isPwdCheckFailedModalOpen,
  onChangePassword,
  onClickPwdNextBtn,
  onClickPwdCheckFailedModalClose,
}: IProps) => {
  return (
    <div className="password-reset-content setting-container">
      <div className="password-reset-card">
        <h2 className="password-reset-title heading-4 font-bold">비밀번호 재설정</h2>

        <div className="password-reset-form">
          <label htmlFor="current-password" className="password-label text-base font-medium">
            기존 비밀번호를 입력해주세요
          </label>
          <input
            type="password"
            id="current-password"
            name="current-password"
            placeholder="기존 비밀번호 입력"
            className="password-input text-base font-normal"
            value={prePassword}
            onChange={onChangePassword}
          />

          <button
            type="button"
            className={clsx('password-complete-btn btn-primary text-lg font-semibold', {
              active: !isPrePasswordCheckedBtn,
            })}
            disabled={isPrePasswordCheckedBtn}
            onClick={onClickPwdNextBtn}
          >
            완료
          </button>
        </div>
      </div>

      {/* 비밀번호 확인 실패 모달 */}
      {/* 비밀번호 확인 실패 모달 */}
      <div className={clsx('modal-overlay', !isPwdCheckFailedModalOpen && 'hidden')} id="passwordMismatchModal">
        <div className="modal-content modal-medium">
          <button type="button" className="modal-close" onClick={onClickPwdCheckFailedModalClose}>
            <img src="./images/close-icon.png" alt="닫기" className="close-icon" />
          </button>

          <div className="modal-body">
            <div className="modal-icon-warning">
              <img src="./images/alert-icon.png" alt="경고" className="modal-icon" />
            </div>

            <h2 className="modal-warning-title text-lg font-bold">비밀번호가 일치하지 않습니다.</h2>

            <button
              type="button"
              className="modal-button text-lg font-semibold"
              onClick={onClickPwdCheckFailedModalClose}
            >
              확인
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PwdSettingView;
